import { AuthenticationData } from '../store/authentication';
import { Kyc, Question, Survey } from '../types/KycTypes';
import { apiClient } from './apiClient';

export const getKnowYourCustomerService = async (
    apiKey: string,
    onlyPep: boolean,
    proxyBaseUrl: string,
    authenticationData?: AuthenticationData,
): Promise<Kyc> => {
    const kycData = await apiClient<Kyc>(`${proxyBaseUrl}/know_your_customer/get_survey?onlyPep=${onlyPep}`, {
        method: 'GET',
        apiKey,
        authenticationData,
        sentryTag: 'get_kyc',
        sentryExtra: { onlyPep },
    });
    kycData.groups.forEach((group: Survey) => {
        group.questions.forEach((question: Question) => {
            question.groupId = group.id;
        });
    });
    return kycData;
};
